import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieBannerComponent } from '@olonera/auth';

@Component({
  imports: [RouterModule, CookieBannerComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected title = 'patient';
}
